import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { ModalService } from "../components/modal";
import { ConfirmationDialog } from "../components/confirmationDialog/ConfirmationDialog";
import { history } from "../router/history";
import { Prompt } from "./Prompt";
import { setLayoutWithPrompt } from "../store/layout";

export const withPromptDialog =
  (Component) =>
  ({ hasChanges, save, discard, ...componentProps }) => {
    const dispatch = useDispatch();

    const handleNavigation = (blocker) => {
      const { location: nextLocation } = blocker;

      const nextAction = nextLocation.state?.nextAction;

      const nextActionDefault = () => {
        history.push(nextLocation.pathname);
      };

      showConfirmationDialog({
        save,
        discard,
        nextAction: nextAction || nextActionDefault,
      })
        .then(() => {})
        .catch((e) => new Error(e));

      return false;
    };

    useEffect(() => {
      dispatch(setLayoutWithPrompt(hasChanges));

      return () => {
        dispatch(setLayoutWithPrompt(false));
      };
    }, [dispatch, hasChanges]);

    return (
      <Fragment>
        <Prompt when={hasChanges} message={handleNavigation} />
        <Component
          {...componentProps}
          hasChanges={hasChanges}
          save={save}
          discard={discard}
        />
      </Fragment>
    );
  };

withPromptDialog.propTypes = {
  hasChanges: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  discard: PropTypes.func.isRequired,
};

/** Default implementation */
export const showConfirmationDialog = ({
  nextAction,
  save,
  discard,
  ...restProps
}) =>
  ModalService.show((modal) => ({
    dialog: <ConfirmationDialog modal={modal} {...restProps} />,
  }))
    .then(({ shouldSave } = {}) => (shouldSave ? save() : discard()))
    .then(() => {
      nextAction();
    })
    .catch(() => {});
